import React from "react";
import classes from "./MultilineTextEllipses.module.css"
const MultilineTextEllipses = props=>{
    return(
        <div className={classes.Text}>
            {props.children}
        </div>
    )
}
export default MultilineTextEllipses;